import React from "react";
import { observer, inject } from "mobx-react";
import { Modal, Button, Table, Form, Row, Col } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DemandPosition, DemandsStore, PrintStore } from "../../../stores";
import { STORE_DEMANDS, STORE_PRINT } from "../../../constants";
import { formatDate, formatMoney, formatDateToMask, formatShortDate } from "../../../common/Formatting";
import { wrapInput } from "../../../common/FormChangeWrapper";

interface IProps {
    isOpened: boolean;
    positions: DemandPosition[];
    cancelCallback: () => void;
    savedCallback: () => void;
}

interface IState {
    demandNumber: string;
    comment: string;
}

@inject(STORE_DEMANDS, STORE_PRINT)
@observer
export class ReleaseModal extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            demandNumber: formatDateToMask(new Date(), "НК0yyMMddhhmmss"),
            comment: ""
        }

    }
    demandsStore = (this.props as any)[STORE_DEMANDS] as DemandsStore;
    printStore = (this.props as any)[STORE_PRINT] as PrintStore;
    notificationStore = this.demandsStore._rootStore.notificationStore;

    private openPrintForm = () => {
        const firstPos = this.props.positions[0];
        this.printStore.drawForm("Demand", {
            demandNumber: this.state.demandNumber,
            positions: this.props.positions,
            sellerName: "",
            customerName: firstPos.customerName,
            customerPhone: firstPos.customerPhone,
        });
        setTimeout(() => {
            window.print();
        }, 400);
    }


    private onFormChange = (fieldName: string, value: string) => {
        (this as any).setState({
            [fieldName]: value
        });
    }

    private saveDemand = () => {
        if (window.confirm(`Сохранение отгрузки № ${this.state.demandNumber}! Продолжить?`))
            this.demandsStore.createDemand(this.state.demandNumber, this.props.positions.map(w => w.id), this.state.comment, () => {
                this.props.savedCallback();
            });
    }

    render() {
        return <Modal show={this.props.isOpened} onHide={this.props.cancelCallback} size="lg" >
            <Modal.Header closeButton>
                <Modal.Title>
                    Отгрузка товара №{this.state.demandNumber} от {formatShortDate(new Date())}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Row>
                        <Col sm="12">
                            <Form.Group as={Row} controlId="formComment">
                                <Form.Label column sm="4">Комментарий</Form.Label>
                                <Col sm="8">
                                    <textarea className="form-control"
                                        name="comment"
                                        value={this.state.comment}
                                        onChange={wrapInput(this.onFormChange)}></textarea>
                                </Col>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Table bordered striped className="table-xxs">
                        <thead>
                            <tr>
                                <th className="text-center">Номер заказа</th>
                                <th className="text-center">Дата создания</th>
                                <th className="text-center">Бренд</th>
                                <th className="text-center">Артикул</th>
                                <th>Описание</th>
                                <th className="text-center">Цена</th>
                                <th className="text-center">Количество</th>
                                <th className="text-center">Сумма</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.positions.map((w, index) => <tr key={index}>

                                <td className="text-center">{w.orderNumber}</td>
                                <td className="text-center">{formatDate(w.dateCreated)}</td>

                                <td className="text-center">{w.brand}</td>
                                <td className="text-center">{w.article}</td>
                                <td>{w.description}</td>
                                <td className="text-center">{formatMoney(w.costSale)}</td>
                                <td className="text-center">{w.count}</td>
                                <td className="text-center">{formatMoney(w.count * w.costSale)}</td>
                            </tr>)}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={7} className="text-right">Итого:</td>
                                <td className="text-center">{formatMoney(this.props.positions.reduce((prev, curr) => prev + curr.costSale * curr.count, 0))}</td>
                            </tr>
                        </tfoot>
                    </Table>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.props.cancelCallback}>
                    Отмена
                </Button>
                <Button variant="secondary" onClick={this.openPrintForm}>
                    <FontAwesomeIcon icon="print" /> {' '}
                    Распечатать накладную
                </Button>
                <Button variant="primary" onClick={this.saveDemand}>
                    <FontAwesomeIcon icon="save" /> {' '}
                    Сохранить отгрузку
                </Button>
            </Modal.Footer>
        </Modal>
    }
}